import { RootState } from 'modules/store';
import { createSlice } from '@reduxjs/toolkit';
import { FreelancerVerificationState, VerificationStatus } from './freelancerVerification.types';
import {
  getFreelancerBulkVerificationResult,
  getFreelancerBulkVerificationResultData,
  getFreelancerVerificationRecords,
  uploadFreelancerBulkVerification,
} from './freelancerVerification.actions';

const initialState: FreelancerVerificationState = {
  verificationRecords: null,
  bulkVerificationResponse: null,
  bulkVerificationResult: null,
  bulkVerificationResultData: null,
  isFetchingVerificationRecords: false,
  isUploadingBulkVerification: false,
  isFetchingBulkVerificationResult: false,
  isFetchingVerificationResultData: false,
};

const freelancerVerificationSlice = createSlice({
  name: 'freelancerVerification',
  initialState,
  reducers: {
    resetBulkVerificationResultData: state => {
      state.bulkVerificationResultData = null;
      state.bulkVerificationResult = null;
      state.isFetchingVerificationResultData = false;
      state.isFetchingBulkVerificationResult = false;
    },
  },
  extraReducers: builder => {
    builder.addCase(uploadFreelancerBulkVerification.pending, state => {
      state.bulkVerificationResponse = null;
      state.isUploadingBulkVerification = true;
    });
    builder.addCase(uploadFreelancerBulkVerification.fulfilled, state => {
      state.bulkVerificationResponse = null;
      state.isUploadingBulkVerification = false;
    });
    builder.addCase(uploadFreelancerBulkVerification.rejected, (state, { payload }) => {
      if (payload) {
        state.bulkVerificationResponse = {
          status: VerificationStatus.failed,
          results_id: '',
          message: payload.message,
          timestamp: new Date().toISOString(),
          status_detail: {
            granular_status_code: payload.errorCode || '',
            status_additional_info: '',
          },
        };
      }
      state.isUploadingBulkVerification = false;
    });
    builder.addCase(getFreelancerVerificationRecords.pending, state => {
      state.isFetchingVerificationRecords = true;
    });
    builder.addCase(getFreelancerVerificationRecords.fulfilled, (state, { payload }) => {
      state.isFetchingVerificationRecords = false;
      state.verificationRecords = payload;
    });
    builder.addCase(getFreelancerVerificationRecords.rejected, state => {
      state.isFetchingVerificationRecords = false;
    });
    builder.addCase(getFreelancerBulkVerificationResult.pending, state => {
      state.isFetchingBulkVerificationResult = true;
    });
    builder.addCase(
      getFreelancerBulkVerificationResult.fulfilled,
      (state, { payload }) => {
        state.isFetchingBulkVerificationResult = false;
        state.bulkVerificationResult = payload;
      },
    );
    builder.addCase(getFreelancerBulkVerificationResult.rejected, state => {
      state.isFetchingBulkVerificationResult = false;
    });
    builder.addCase(
      getFreelancerBulkVerificationResultData.pending,
      (state, { meta }) => {
        if (!meta.arg.isCsvFile) {
          state.isFetchingVerificationResultData = true;
        }
      },
    );
    builder.addCase(
      getFreelancerBulkVerificationResultData.fulfilled,
      (state, { payload, meta }) => {
        if (!meta.arg.isCsvFile) {
          state.isFetchingVerificationResultData = false;
          state.bulkVerificationResultData = payload;
        }
      },
    );
    builder.addCase(getFreelancerBulkVerificationResultData.rejected, state => {
      state.isFetchingVerificationResultData = false;
    });
  },
});

export default freelancerVerificationSlice.reducer;
export const selectFreelancerVerificationState = (state: RootState) => state.root.freelancerVerification;
export const { resetBulkVerificationResultData } = freelancerVerificationSlice.actions;

